import { useEffect } from "react";
import { useState } from "react";
import { useDispatch } from "react-redux";
import DynamicTable from "src/components/table";
import {
  columntype,
  dataLocalStorage,
  getLocalStorage,
  inputType,
  isValidArray,
} from "src/helper/publicFunction";
import {
  ManageFleet,
  DeleteFleet,
  EditFleet,
  GetFleet,
} from "./actions";
import DynamicModal from "src/components/modal/DynamicModal";
import * as Yup from "yup";
import { CommonAlert } from "src/components/alert/CommonAlert";
import { useNavigate } from "react-router";
import { id } from "date-fns/locale";
const Fleet = () => {
  const dispatch = useDispatch();
  const Commonalert = CommonAlert(); // Create an alert object using the function
  const [page, setPage] = useState(0);
  const navigate = useNavigate();
  const [rowsPerPage, setRowsPerPage] = useState(50);
  const [search, setSearch] = useState("");
  const [selected, setSelected] = useState([]);
  const [loadingData, setLoadingData] = useState(true);
  const [loadingEditdatatype, setloadingEditdatatype] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [array, setarray] = useState([]);
  const [values, setvalues] = useState({});
  const [editMode, setEditMode] = useState(false);
  const [data, setData] = useState([]);
  const [TotalData, setTotalData] = useState(0);
  let dataPrivileges = getLocalStorage(dataLocalStorage.privileges);
  const Schema = Yup.object().shape({
    type: Yup.string().trim().required("Type is required"),
    content: Yup.string().when('type', {
      is: 'description',
      then: Yup.string().required('Content is required'),
      otherwise: Yup.string().notRequired(),
    }),
    image_url: Yup.string().when('type', {
      is: 'image',
      then: Yup.string().required('Image is required'),
      otherwise: Yup.string().notRequired(),
    }),
    carType: Yup.string().when('type', {
      is: 'image',
      then: Yup.string().required('Car Type is required'),
      otherwise: Yup.string().notRequired(),
    }),
    passengers: Yup.number().when('type', {
      is: 'image',
      then: Yup.number().required('Number of passengers is required').positive().integer(),
      otherwise: Yup.number().notRequired(),
    }),
    // order_nbr: Yup.number().required("Order Number is required"),
  });


  const setDataModal = (editValues = null) => {
    const baseFields = [
      {
        failed: "id",
        type: inputType.text,
        title: "id",
        placeholder: "",
        fullwidth: true,
        customdesign: { display: "none" },
      },

      {
        failed: "type",
        type: inputType.dropdown,
        title: "Type",
        placeholder: "",
        datadropdown: [
          { value: "", name: "Select type" },
          { value: "description", name: "Text" },
          { value: "image", name: "Image" },
        ],
        faileddropdown: {
          name: "name",
          value: "value",
        },
        fullwidth: true,
        customdesign: { width: "100%" },
      },
    ];

    if (editValues) {
      if (editValues.type === "description") {
        setarray([
          ...baseFields,
          {
            failed: "content",
            type: inputType.text,
            title: "Content",
            placeholder: "",
            fullwidth: true,
            customdesign: { width: "100%" },
            required: true,
          },

        ]);
      } else if (editValues.type === 'image') {
        setarray([
          ...baseFields,
          {
            failed: "image_url",
            type: inputType.image,
            title: "Image",
            placeholder: "",
            fullwidth: true,
            customdesign: { width: "100%" },
            required: true,
          },
          {
            failed: "carType",
            type: inputType.text,
            title: "Car Type",
            placeholder: "Enter car type",
            fullwidth: true,
            customdesign: { width: "100%" },
            required: true,
          },
          {
            failed: "passengers",
            type: inputType.text,
            title: "Passengers",
            placeholder: "Enter number of passengers",
            fullwidth: true,
            customdesign: { width: "100%" },
            required: true,
          },
        ]);
      }
    } else {
      setarray(baseFields);
    }
  }
  const GetData = () => {
    setLoadingData(true);
    setData([]);
    dispatch(
      GetFleet({
        callback: (data) => {
          if (isValidArray(data?.data)) {
            setData(data?.data);
            if (array.length == 0) {
              setDataModal();
            }
          } else {
            setDataModal();
            setData([]);
          }
          setLoadingData(false);
        },
      })
    );
  };

  useEffect(() => {
    GetData({ tableName: null, type: null });
  }, [page, rowsPerPage, search]);

  const columns = [
    { type: columntype.text, name: "id" },
    { type: columntype.text, name: "type" },
    { type: columntype.image, name: "image_url" },
    { type: columntype.text, name: "content" },
    // { type: columntype.text, name: "order_nbr" },
    { type: columntype.switch, name: "is_active" },
    // { type: columntype.switch, name: "has_btn" },
  ];

  const headCells = [
    {
      id: "id",
      numeric: false,
      disablePadding: false,
      label: "id",
      withSort: true,
    },
    {
      id: "type",
      numeric: false,
      disablePadding: false,
      label: "Type",
      withSort: false,
    },
    {
      id: "image_url",
      numeric: false,
      disablePadding: false,
      label: "Image",
      withSort: false,
    },
    // {
    //   id: 'order_nbr',
    //   numeric: true,
    //   disablePadding: false,
    //   label: "Order",
    //   withSort: false,
    // },
    // {
    //   id: "has_btn",
    //   numeric: false,
    //   disablePadding: false,
    //   label: "Button",
    //   withSort: false,
    // },
    {
      id: "is_active",
      numeric: false,
      disablePadding: false,
      label: "Active",
      withSort: false,
    },
    (dataPrivileges["3"]?.access_delete == 1 ||
      dataPrivileges["3"]?.access_edit == 1) && {
      id: "action",
      numeric: false,
      disablePadding: false,
      label: "Action",
      withSort: false,
    },
  ];

  const List = [
    dataPrivileges["3"]?.access_delete == 1 && {
      name: "Delete",
      function: async (row) => {
        if (row) {
          Commonalert.show({
            title: `Are you sure to delete ${row?.username ?? ""}?`,
            message: "You won't be able to revert this!",
            type: "delete",
            actions: [
              {
                name: "Yes",
                callback: () =>
                  dispatch(
                    DeleteFleet({
                      callback: () => {
                        GetData({ tableName: null, type: null });
                      },
                      id: [row.id],
                    })
                  ),
                type: "delete",
              },
              {
                name: "No",
                callback: () => { },
                type: "cancel",
              },
            ],
          });
        }
      },
    },
    dataPrivileges["3"]?.access_edit == 1 && {
      name: "Edit",
      function: async (data) => {
        setEditMode(true);
        setvalues(data);
        setShowModal(true);
        setDataModal(data);
      },
    },
  ];



  const updateDataApi = ({ row, failedName, newData }) => {
    setloadingEditdatatype(`${row?.id}-${failedName}`);

    // if (failedName === "has_btn" && row.type === "image") {
    //   setloadingEditdatatype("");
    //   return;
    // }

    // if (failedName === "has_btn" && newData === 1) {
    //   dispatch(
    //     EditFleet({
    //       FleetId: row?.id,
    //       dataFailed: newData,
    //       nameFailed: failedName,
    //       callback: () => {
    //         const otherItems = data.filter(item =>
    //           item.id !== row.id &&
    //           item.has_btn === 1 &&
    //           item.type !== "image"
    //         );

    //         if (otherItems.length > 0) {
    //           const updatePromises = otherItems.map(item => {
    //             return new Promise((resolve) => {
    //               dispatch(
    //                 EditFleet({
    //                   FleetId: item.id,
    //                   dataFailed: 0,
    //                   nameFailed: "has_btn",
    //                   callback: (response) => {
    //                     if (response) {
    //                       updateDataLocal({ id: item.id, failedName: "has_btn", newData: 0 });
    //                     }
    //                     resolve();
    //                   },
    //                 })
    //               );
    //             });
    //           });
    //           Promise.all(updatePromises).then(() => {
    //             updateDataLocal({ id: row.id, failedName, newData });
    //           });
    //         } else {
    //           updateDataLocal({ id: row.id, failedName, newData });
    //         }
    //       },
    //     })
    //   );
    // } else {
    dispatch(
      EditFleet({
        FleetId: row?.id,
        dataFailed: newData,
        nameFailed: failedName,
        callback: () => {
          updateDataLocal({ id: row.id, failedName, newData });
        },
      })
    );
    // }
  };
  const updateDataLocal = ({ id, failedName, newData }) => {
    setData((prevData) => {
      return prevData.map((item) => {
        if (item.id === id) {
          return {
            ...item,
            [failedName]: newData,
          };
        }
        return item;
      });
    });
    setloadingEditdatatype("");
  };

  return (
    <>
      <DynamicTable
        handleSearch={(event) => setSearch(event.target.value)} // call api
        onRequestSort={(tableName, type) => {
          if (tableName && type) {
            GetData({ tableName, type });
          }
        }} // call api
        onPressDelete={(ListIds) => {
          Commonalert.show({
            title: "Are you sure?",
            message: "You won't be able to revert this!",
            type: "delete",
            actions: [
              {
                name: "Yes",
                callback: () =>
                  dispatch(
                    DeleteFleet({
                      callback: () => {
                        GetData({ tableName: null, type: null });
                      },
                      id: ListIds,
                    })
                  ),
                type: "delete",
              },
              {
                name: "No",
                callback: () => { },
                type: "cancel",
              },
            ],
          });
        }} // call api

        onPressItem={(row) => { }} // when press item
        onPressAnyAction={(row, failedName, newData) => {
          updateDataApi({ row, failedName, newData });
        }} // when press checkbox or switch
        onPressAdd={() => {
          setvalues({});
          setEditMode(false);
          setDataModal();
          setShowModal(true);
        }} // when press add new button show modal to add new item
        items={data} // all data
        columns={columns} // type of data
        headCells={headCells} // columns name
        page={page} // number of page from api
        setPage={setPage} // set number of page from api
        selected={selected} // selected items
        setSelected={setSelected} // set selected items
        search={search} // search failed
        rowsPerPage={rowsPerPage} // number show Data
        setRowsPerPage={setRowsPerPage} // set number show data
        Listdropdown={List} // list action with function
        withOption={true} // for remove action column
        loadingData={loadingData} // when load data from api
        rowsPerPageOptions={[5, 10, 25, 50]} // set option number of show data
        totalItem={TotalData} // total data without pagination
        loadingEditdatatype={loadingEditdatatype} // first failed (id) and second (failed Name) like ={"1-is_active"}
        withAddButton={dataPrivileges["3"]?.access_write == 1 ? true : false}
        withDeleteItem={dataPrivileges["3"]?.access_delete == 1 ? true : false}
        withEditItem={dataPrivileges["3"]?.access_edit == 1 ? true : false}
        withPagination={false}
        withSearch={false}
      />
      {showModal ? (
        <DynamicModal
          show={showModal}
          setShow={setShowModal}
          faileds={array}
          values={values}
          title={"Fleets"}
          editMode={editMode}
          description={editMode ? "Edit" : "Add a new Fleet"}
          buttonTitle={editMode ? "Save" : "Save"}
          onChange={({ value, failedName, setFieldValue }) => {
            if (failedName == "type") {
              const baseFields = [
                {
                  failed: "id",
                  type: inputType.text,
                  title: "id",
                  placeholder: "",
                  fullwidth: true,
                  customdesign: { display: "none" },
                },
                {
                  failed: "type",
                  type: inputType.dropdown,
                  title: "Type",
                  placeholder: "",
                  datadropdown: [
                    { value: "description", name: "Text" },
                    { value: "image", name: "Image" },
                  ],
                  faileddropdown: {
                    name: "name",
                    value: "value",
                  },
                  fullwidth: true,
                  customdesign: { width: "100%" },
                },
              ];
              if (value == "description") {
                setarray([
                  ...baseFields,
                  {
                    failed: "content",
                    type: inputType.text,
                    title: "Content",
                    placeholder: "",
                    fullwidth: true,
                    customdesign: { width: "100%" },
                    required: true,
                  },
                  // {
                  //   failed: "order_nbr",
                  //   type: inputType.text,
                  //   title: "Order Number",
                  //   placeholder: "",
                  //   fullwidth: true,
                  //   customdesign: { width: "100%" },
                  //   required: true,
                  // },
                ]);
                setFieldValue('image_url', '');
                setFieldValue('carType', '');
                setFieldValue('passengers', '');
              } else if (value === 'image') {
                setarray([
                  ...baseFields,
                  {
                    failed: "image_url",
                    type: inputType.image,
                    title: "Image",
                    placeholder: "",
                    fullwidth: true,
                    customdesign: { width: "100%" },
                    required: true,

                  },
                  {
                    failed: "carType",
                    type: inputType.text,
                    title: "Car Type",
                    placeholder: "Enter car type",
                    fullwidth: true,
                    customdesign: { width: "100%" },
                    required: true,

                  },
                  {
                    failed: "passengers",
                    type: inputType.text,
                    title: "Passengers",
                    placeholder: "Enter number of passengers",
                    fullwidth: true,
                    customdesign: { width: "100%" },
                    required: true,
                  },
                  // {
                  //   failed: "order_nbr",
                  //   type: inputType.text,
                  //   title: "Order Number",
                  //   placeholder: "",
                  //   fullwidth: true,
                  //   customdesign: { width: "100%" },
                  //   required: true,
                  // },
                ]);
                setFieldValue('content', '');
              }
            }
          }}
          onSubmit={(valuess) => {
            dispatch(
              ManageFleet({
                editMode: editMode,
                values: valuess,
                callback: (res) => {
                  if (res) {
                    setShowModal(false);
                    GetData({ tableName: null, type: null });
                    if (!editMode) {
                      setvalues({});
                      setDataModal();
                    }
                  }
                },
              })
            );
          }}
          Schema={Schema}
        />
      ) : null}
    </>
  );
};

export default Fleet;
